import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  PartnerCreatePayload,
  PartnerDashboardCounts,
  PartnerListItem,
  PartnerListQuery,
  PartnerRead,
  PartnerStatus,
  PartnerStatusPayload,
  PartnerUpdatePayload,
} from '../models/partner-management';
import {
  PartnerAvailabilityDayPayload,
  PartnerAvailabilityDayResponse,
  PartnerScheduleQuery,
  PartnerScheduleResponse,
} from '../models/partner-schedule';

export const PartnerManagementActions = createActionGroup({
  source: 'Partner Management',
  events: {
    'Load List': props<{ query: PartnerListQuery }>(),
    'Load List Success': props<{
      rows: PartnerListItem[];
      total: number;
      page: number;
      pageSize: number;
      counts: PartnerDashboardCounts;
    }>(),
    'Load List Failure': props<{ error: string }>(),
    'Load Partner': props<{ partnerId: string }>(),
    'Load Partner Success': props<{ partner: PartnerRead }>(),
    'Load Partner Failure': props<{ error: string }>(),
    'Load Schedule': props<{
      partnerId: string;
      query: PartnerScheduleQuery;
    }>(),
    'Load Schedule Success': props<{
      partnerId: string;
      query: PartnerScheduleQuery;
      schedule: PartnerScheduleResponse;
    }>(),
    'Load Schedule Failure': props<{ error: string }>(),
    'Update Schedule Availability': props<{
      partnerId: string;
      payload: PartnerAvailabilityDayPayload;
      query: PartnerScheduleQuery;
    }>(),
    'Update Schedule Availability Success': props<{
      response: PartnerAvailabilityDayResponse;
    }>(),
    'Update Schedule Availability Failure': props<{ error: string }>(),
    'Create Partner': props<{ payload: PartnerCreatePayload }>(),
    'Update Partner': props<{
      partnerId: string;
      payload: PartnerUpdatePayload;
    }>(),
    'Persist Success': props<{ message: string; partner: PartnerRead }>(),
    'Persist Failure': props<{ error: string }>(),
    'Update Partner Status': props<{
      partnerId: string;
      status: PartnerStatus | PartnerStatusPayload;
    }>(),
    'Update Partner Status Success': props<{
      message: string;
      partner: PartnerRead;
    }>(),
    'Update Partner Status Failure': props<{ error: string }>(),
    'Clear Error': emptyProps(),
    'Clear Success Message': emptyProps(),
  },
});
